import {Component, ElementRef, Input, OnInit, DOCUMENT, inject} from '@angular/core';
import {isElementRef} from '../../_utils/type-guards';

import {Router, RouterLink} from '@angular/router';
import {I18nService} from '../../_services/gui/i18n.service';
import {reformatDate} from 'src/app/_utils/lang';
import {TranslateModule} from '@ngx-translate/core';

@Component({
    selector: 'app-pdf-button-bar',
    templateUrl: './pdf-button-bar.component.html',
    styleUrls: ['./pdf-button-bar.component.scss'],
    imports: [RouterLink, TranslateModule]
})
export class PdfButtonBarComponent implements OnInit {


  @Input() documentRootElement: HTMLElement | ElementRef | HTMLElement[] | ElementRef[];
  @Input() newOrderUrl: string;
  @Input() css: string;

  html: string;
  private document = inject(DOCUMENT);
  private router = inject(Router);
  private i18nService = inject(I18nService);

  ngOnInit(): void {
  }

  pdf() {
    const elements: HTMLElement[] = [].concat(this.documentRootElement).map(e => isElementRef(e) ? e.nativeElement : e);
    this.html = elements.map(e => e.outerHTML).join('').replace(/<!--.*?[\s\S]*?.*?[\s\S]*?.*?-->/g, ''); //TODO: verify comments need to be removed for output

    // creates a html page with the contents of the report
    const htmlWithCss = `<html><head><meta charset="UTF-8"><style>${this.css}</style></head><body>${this.html}</body></html>`;
    const blob = new Blob([htmlWithCss], {type: 'text/html'});
    const url = window.URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.target = '_blank';
    // opens the report in new tab and triggers print preview
    let pdfWindow = window.open(url, '_blank');
    // get the current timestamp
    const timeStamp = reformatDate(new Date(), 'YYYY-MM-DD HH:mm:ss').toString();
    // page should be loaded
    pdfWindow.onload = () => {
      pdfWindow.focus();
      pdfWindow.print();
      // setting the name of the pdf report
      pdfWindow.onbeforeprint = () => {
        if(this.i18nService.currentLangShortCode === 'FR') {
          pdfWindow.document.title = 'transunion-rapport-'+ timeStamp;
        } else if(this.i18nService.currentLangShortCode === 'EN') {
          pdfWindow.document.title = 'transunion-report-'+ timeStamp;
        }
      }
      // after print is done or cancelled the tab should be closed
      pdfWindow.onafterprint = () => {
        pdfWindow.close();
      }
    }
  }

}
